export const UPLOAD_IN_PROGRESS = "Please wait, document upload still in progress."